import template from './footer.html';
import controller from './footer.controller';
import './footer.scss';

const footerComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default footerComponent;
